module.exports = __webpack_public_path__ + "static/media/16.e9f3420a.jpg";